export default __webpack_public_path__ + "static/media/consent.e95b8cbb.svg";